module.exports = __webpack_public_path__ + "static/media/icon-male.1a19ba4a.svg";